// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".level-container[data-v-71b5742d] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.level-container .col[data-v-71b5742d] {\n  padding: 0px 2px !important;\n}\n.level-container__radio[data-v-71b5742d] {\n  border: 1px solid #e2e2e2;\n  border-radius: 20px;\n  width: 21px;\n  height: 21px;\n}\n.level-container__radio--selected[data-v-71b5742d] {\n  background: #2db782;\n  width: 11px;\n  height: 11px;\n  border-radius: 50px;\n}", ""]);
// Exports
module.exports = exports;
